import React from 'react';
import { useAnimatedProps, useDerivedValue, useSharedValue } from 'react-native-reanimated';
import { AnimatedTextInput } from 'design-system/AnimatedComponents';
import BlurAmountView from 'design-system/BlurAmountView';
import { useAppSelector } from 'store/hooks';
function ChartLabelFactory(style) {
    const ChartLabel = ({ format, contextValue, useOriginalY, useOriginalX, keyToUse, keysToUse, ...props }) => {
        const scrambled = useAppSelector((store) => store.utils.scrambled);
        const { originalData, providedData, originalX, originalY } = contextValue;
        const forPortfolio = useSharedValue('forPortfolio' in props);
        const formattedValue = useDerivedValue(() => {
            if (format) {
                if (useOriginalY) {
                    return format(originalY.value);
                }
                if (useOriginalX) {
                    return format(originalX.value);
                }
                if (originalData) {
                    if (originalX) {
                        if (originalX.value) {
                            if (keyToUse) {
                                if (!providedData || providedData.points.length === 0)
                                    return '';
                                const x = parseInt(originalX.value, 10);
                                const data = originalData[keyToUse];
                                if (forPortfolio.value) {
                                    return format(data[x]);
                                }
                                const index = Math.round(x * (data.length / providedData.points.length));
                                return format(data[index]);
                            }
                            if (keysToUse) {
                                if (!providedData || providedData.points.length === 0)
                                    return '';
                                const x = parseInt(originalX.value, 10);
                                const data0 = originalData[keysToUse[0]];
                                const data1 = originalData[keysToUse[1]];
                                if (forPortfolio.value) {
                                    return format(data0[x], data1[x]);
                                }
                                const index = Math.round(x * (data0.length / providedData.points.length));
                                return format(data0[index], data1[index]);
                            }
                        }
                    }
                }
            }
            return format('');
        }, [originalData, useOriginalY, format]);
        const textProps = useAnimatedProps(() => ({
            text: formattedValue.value,
        }), [formattedValue]);
        let defaultValue = '';
        if (format) {
            if (style === 'x') {
                if (!originalX || originalX.value === '') {
                    defaultValue = format('');
                }
            }
            if (style === 'y') {
                if (!originalX || originalX.value === '') {
                    defaultValue = format('');
                }
            }
        }
        return (<BlurAmountView enabled={scrambled}>
        <AnimatedTextInput {...props} animatedProps={textProps} defaultValue={defaultValue} editable={false} allowFontScaling={false}/>
      </BlurAmountView>);
    };
    return ChartLabel;
}
export const ChartYLabel = ChartLabelFactory('y');
export const ChartXLabel = ChartLabelFactory('x');
